var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { useTranslation } from "react-i18next";
function Button(_a) {
    var type = _a.type, icon = _a.icon, label = _a.label, handleClick = _a.handleClick;
    var t = useTranslation().t;
    if (type === "link") {
        return (_jsxs("button", __assign({ type: "button", title: "Reset filters", onClick: handleClick, className: "widget-button twc-w-fit twc-flex twc-flex-row twc-gap-2 twc-justify-center twc-items-center" }, { children: [icon, _jsx("span", __assign({ className: "twc-text-[#D8B97D] twc-text-sm twc-font-medium twc-ml-4" }, { children: t("resetFilters") }))] })));
    }
    if (type === "secondary") {
        return (_jsxs("button", __assign({ type: "button", onClick: handleClick, className: "widget-button twc-bg-[#212225] twc-border twc-border-[#D8B97D] twc-leading-[28px] twc-flex twc-gap-2 twc-items-center twc-justify-center twc-w-full twc-h-[50px] twc-px-[20px] twc-py-[6px] twc-rounded-[10px]" }, { children: [icon, _jsx("span", __assign({ className: "twc-text-[#D8B97D] twc-text-[14px] twc-font-bold" }, { children: t(label) }))] })));
    }
    return (_jsxs("button", __assign({ type: "button", onClick: handleClick, className: "widget-button twc-bg-[#D8B97D] twc-leading-[28px] twc-flex twc-gap-2 twc-items-center twc-justify-center twc-w-full twc-h-[50px] twc-px-[20px] twc-py-[6px] twc-rounded-[10px]" }, { children: [icon, _jsx("span", __assign({ className: "twc-text-[#212225] twc-text-[14px] twc-font-bold" }, { children: t(label) }))] })));
}
export var MemoizedButton = memo(Button);
